// Helper function to get translations from the global rollenfinderTranslations object
export function getTranslation(key, replacements = {}) {
  try {
    // Split the key into parts (e.g., "steps.step_1.title" -> ["steps", "step_1", "title"])
    const parts = key.split('.');
    
    // Get the translation from the global object
    let value = window.rollenfinderTranslations;
    for (const part of parts) {
      value = value?.[part];
      if (value === undefined) {
        console.warn(`Translation missing for key: ${key}`);
        return key; // Return the key as fallback
      }
    }

    // Replace any placeholders in the translation
    if (typeof value === 'string') {
      return Object.entries(replacements).reduce((str, [key, val]) => {
        return str.replace(`{${key}}`, val);
      }, value);
    }

    return value;
  } catch (error) {
    console.warn(`Error getting translation for key: ${key}`, error);
    return key; // Return the key as fallback
  }
} 